import { css } from '@emotion/css';

export const plyrStyles = css`
  .ProseMirror .plyr {
    box-shadow: var(--shadow-02);
    border-radius: 0.8rem;
  }

  @media (max-width: 767px) {
    .ProseMirror .plyr__video-wrapper {
      display: flex;
      align-items: center;
      video {
        max-height: 64rem;
        min-height: 24rem;
      }
    }
  }
`;
